// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__soWKr","container":"styles_container__sFnnY","list":"styles_list__pOOJH"};